import React from 'react'

const NoDataFound: React.FC<{ message?: string }> = ({ message = 'No Data Found' }) => {
    return (
        <div className="d-flex w-100 justify-content-center align-items-center">
            <div className="length-zero my-2">
                <h3>{message}</h3>
            </div>
        </div>
    )
}

export default NoDataFound